import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { DateTimePicker } from "./DateTimePicker";
import { useFormikContext } from "formik";
import { isValid } from "date-fns";
import clsx from "clsx";

export const DateTimeRangeField = () => {
  const { values } = useFormikContext();

  // check if now is within the chosen onSaleFrom and onSaleTo range
  const now = new Date();
  const onSaleFrom = new Date(values.onSaleFrom);
  const onSaleTo = new Date(values.onSaleTo);
  const isOnSale =
    isValid(onSaleFrom) &&
    isValid(onSaleTo) &&
    now >= onSaleFrom &&
    now <= onSaleTo;

  return (
    <div>
      <div className="flex items-center">
        <DateTimePicker name="onSaleFrom" hasTime={true} />
        <div className="flex px-3">
          <ArrowRightIcon className="h-5 w-5 text-white stroke-2" />
        </div>
        <DateTimePicker name="onSaleTo" hasTime={true} />
      </div>
      <div className="relative flex mt-4 flex items-center">
        <div className="mr-2 relative h-4 w-4">
          <div
            className={clsx(
              "animate-ping h-4 w-4 rounded-full",
              isOnSale ? "bg-green-500/10" : "bg-red-500/10"
            )}
          ></div>
          <div
            className={clsx(
              "absolute h-2 w-2 rounded-full absolute top-0 translate-x-1/2 translate-y-1/2",
              isOnSale ? "bg-green-500" : "bg-red-500"
            )}
          />
          {/* <div className="h-3 w-3 mt-2 bg-red-400 text-green-400 bg-green-500/10 rounded-full animate-ping"></div>
          <div className="absolute h-2 w-2 rounded-full bg-green-500 absolute top-1/2 -translate-y-1/2" /> */}
        </div>
        {isOnSale ? (
          <span className="font-normal text-sm">On Sale Now</span>
        ) : (
          <span className="font-normal text-sm">Not currently on sale</span>
        )}
      </div>
    </div>
  );
};
